
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Analytics_dashboard extends Vue {}
